"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M.48 1a.48.48 0 0 1 .478.48v21.562h21.563a.48.48 0 0 1 0 .958H.479A.48.48 0 0 1 0 23.52V1.48A.48.48 0 0 1 .48 1Zm22.283.065a.48.48 0 0 1 .173.656l-6.709 11.5a.477.477 0 0 1-.797.046l-2.447-3.263L7.6 18.976a.485.485 0 0 1-.389.232.497.497 0 0 1-.407-.191l-1.019-1.358-2.025 3.24a.478.478 0 1 1-.812-.507l2.396-3.834a.475.475 0 0 1 .385-.224.447.447 0 0 1 .404.192l1.01 1.346L12.526 8.9a.48.48 0 0 1 .388-.233.514.514 0 0 1 .408.191l2.442 3.256 6.344-10.876a.48.48 0 0 1 .655-.173Z",
    clipRule: "evenodd"
  })]
});